/**
 * custom cookie trigger
 */
(() => {
  const cookieTrigger = document.querySelector('.cookiespolicies-manager-btn');
  const customTrigger = document.querySelector('a[href="cookieTrigger"]');
  if (cookieTrigger && customTrigger) {
    customTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      cookieTrigger.click();
    });
  }
})();

/**
 * ECOMM02-3930 - Auto trigger cookies
 */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    let hasConsentUuid = false;
    try {
      hasConsentUuid = !!window.localStorage?.getItem('user_consent_uuid');
    } catch (e) {
      // localStorage can be blocked (privacy mode / policies). If so, fall back to running normally.
    }

    if (hasConsentUuid) return;

    setTimeout(() => {
      const cookieTrigger = document.querySelector('.cookiespolicies-manager-btn');
      if (cookieTrigger) {
        cookieTrigger.click();
      }
    }, 1);
  });
})();
